import { Button } from '@medly-components/core';
import { MAP_ONBOARDING } from 'constants/routes';
import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { GET_STARTED_NOW, REQUEST_MAP_DESCRIPTION, REQUEST_MAP_HEADER } from 'constants/text/myMap';
import { ReactComponent as Icon } from '../../../../assets/images/requestMap/request.svg';
import MyMapInfo from '../MyMapInfo';

export const RequestMap: FC = () => {
    const navigate = useNavigate();
    const submit = useCallback(() => {
        navigate(MAP_ONBOARDING);
    }, [navigate]);

    return (
        <MyMapInfo
            title={REQUEST_MAP_HEADER}
            description={REQUEST_MAP_DESCRIPTION}
            action={<Button onClick={submit}>{GET_STARTED_NOW}</Button>}
            icon={<Icon />}
        />
    );
};

RequestMap.displayName = 'RequestMap';
